// morpheus-specific color variables
export const colorVars = {
  utkColorHeaderPrimary: '#2f3a43',
  utkColorSidebarPrimary: '#44525d',
  utkColorSidebarSecondary: '#345771', // $utk-color-navy-blue
  utkColorSidebarSelectedItem: '#377a93', // $utk-color-aqua-blue
  utkColorAuctionCool: '#f5f3f2',
}
